import { PropsWithChildren } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { adminRoutes } from '~/routes/routes'

import { Header } from '../../Sales/Header'

export const LicensesLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation()

  return (
    <main className='flex flex-1 flex-col bg-slate-100 overflow-hidden'>
      <Header />

      <div className='flex gap-4 p-5 pb-0'>
        <Link
          to={adminRoutes.licenses.extensions}
          data-selected={location.pathname.includes('avulsas')}
          className='rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30'
        >
          Licenças Avulsas
        </Link>
        <Link
          to={adminRoutes.licenses.purchases}
          data-selected={location.pathname.includes('compras')}
          className='rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30'
        >
          Compras de Licenças
        </Link>
      </div>
      {children}
    </main>
  )
}
